import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
const { FiX, FiTrash2, FiRotateCcw } = FiIcons;
import SafeIcon from '../common/SafeIcon';

export default function TrashModal({ snippets, onClose, onRestore }) {
  const deleted = (snippets || [])
    .filter(s => s.isDeleted)
    .sort((a,b) => Number(b.updatedAt || 0) - Number(a.updatedAt || 0));

  return (
    <motion.div initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}} className="fixed inset-0 z-[186] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm">
      <motion.div initial={{scale:.96,opacity:0}} animate={{scale:1,opacity:1}} exit={{scale:.96,opacity:0}} className="flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-3xl border border-gray-700 bg-gray-900 shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-800 p-6">
          <div className="flex items-center gap-3">
            <div className="rounded-xl bg-red-500/10 p-2 text-red-300"><SafeIcon icon={FiTrash2} /></div>
            <div>
              <h2 className="text-xl font-bold text-white">Trash & Recovery</h2>
              <p className="text-xs text-gray-500">{deleted.length} deleted snippet{deleted.length === 1 ? '' : 's'} can be restored.</p>
            </div>
          </div>
          <button onClick={onClose} className="rounded-full p-2 text-gray-500 hover:bg-gray-800 hover:text-white"><SafeIcon icon={FiX} /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {deleted.length === 0 ? (
            <div className="py-16 text-center text-sm text-gray-500">Trash is empty.</div>
          ) : (
            <div className="space-y-2">
              {deleted.map(s => (
                <div key={s.id} className="flex items-center justify-between gap-3 rounded-xl border border-gray-800 bg-gray-950/40 px-4 py-3">
                  <div className="min-w-0">
                    <div className="truncate text-sm font-semibold text-gray-200">{s.title || 'Untitled Snippet'}</div>
                    <div className="text-[10px] text-gray-500">
                      Deleted {s.updatedAt ? new Date(Number(s.updatedAt)).toLocaleString() : 'previously'}
                    </div>
                  </div>
                  <button onClick={() => onRestore(s.id)} className="shrink-0 rounded-xl bg-emerald-500/10 px-3 py-2 text-xs font-bold text-emerald-300 hover:bg-emerald-500/20">
                    <SafeIcon icon={FiRotateCcw} className="mr-1 inline" /> Restore
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
}